// extracted by mini-css-extract-plugin
export default {"container":"noData_container__8RHqv","image":"noData_image__E9Ve6","message":"noData_message__J0wu4","text":"noData_text__ZzvlK"};